module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-04-fda416e889e16aaafede9e74be9a5645.svg";